export const DateTimeFormats = {
  HTML_INPUT_DATETIME: "yyyy-MM-dd'T'HH:mm",
  GLPI_DATETIME: "yyyy-MM-dd HH:mm:ss"
};
